import { render, staticRenderFns } from "./CadastroDeTabelas.vue?vue&type=template&id=31eb7271&"
import script from "./CadastroDeTabelas.vue?vue&type=script&lang=js&"
export * from "./CadastroDeTabelas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports